(function () {

    'use strict';

    angular.module('Services').factory('ServicesTableService', ServicesTableService);
    ServicesTableService.$inject = [
        'TableLiteFactory',
        'ServicesService',
        '$filter',
        '$location',
        'Carrier',
        'ClientService',
        '$q'
    ];

    function ServicesTableService(
        TableLiteFactory,
        ServicesService,
        $filter,
        $location,
        Carrier,
        ClientService,
        $q
    ) {
        return function (additionalFilters = {}) {
            var servicesTable = {
                tableName: 'MarginsTable',
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add new connection',
                        tooltip: 'Click to add new Connection',
                        onClick: function () {
                            $location.path('/margins/new');
                        }
                    }]
                },
                headers: [
                    {
                        label: 'PROFILE NAME',
                        viewName: 'name',
                        filterName: 'name',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'CARRIER PROFILE',
                        viewName: 'carrierProfileName',
                        filterName: 'carrierProfileId',
                        sortName: 'carrierProfile.name',
                        filter: {
                            type: 'autoComplete',
                            placeholder: 'Search',
                            viewName: 'name',
                            filterBy: 'id',
                            items: [],
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            },
                            refresh: function (model) {
                                const defer = $q.defer();
                                let filterItems = this.items;
                                Carrier.carrierProfilesCompact((data) => {
                                    filterItems.length = 0;
                                    angular.forEach(data.content, (profile) => {
                                        filterItems.push(profile);
                                    });
                                    filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                    defer.resolve();
                                }, (error) => {
                                    defer.reject();
                                }, { size: 10, name: model })
                                return defer.promise;
                            }
                        },
                        headerFn: function () {
                            sort(this.sortName);
                        }
                    },
                    {
                        label: 'SERVICE PROFILE',
                        viewName: 'serviceProfileName',
                        filterName: 'serviceProfileId',
                        sortName: 'serviceProfile.name',
                        filter: {
                            type: 'autoComplete',
                            placeholder: 'Search',
                            viewName: 'displayName',
                            filterBy: 'id',
                            items: [],
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            },
                            refresh: function (model) {
                                const defer = $q.defer();
                                let filterItems = this.items;
                                Carrier.serviceProfilesCompact((data) => {
                                    filterItems.length = 0;
                                    angular.forEach(data.content, (profile) => {
                                        filterItems.push(profile);
                                    });
                                    filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                    defer.resolve();
                                }, (error) => {
                                    console.log(error);
                                    defer.reject();
                                }, { size: 10, name: model, carrierProfileId: activeFilters.carrierProfileId })
                                return defer.promise;
                            }
                        },
                        headerFn: function () {
                            sort(this.sortName);
                        }
                    },
                    {
                        label: 'COMPANY',
                        viewName: 'companyName',//to fix
                        filterName: 'companyName',//to fix
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'MARGIN MIN VALUE',
                        viewName: 'marginMinValueFormatted',
                    },
                    {
                        label: 'MARGIN PERCENTAGE',
                        viewName: 'marginPercentFormatted',
                    }, {
                        label: 'STATUS',
                        viewName: 'status',
                        filterName: 'enabled',
                        filter: {
                            type: 'select2',
                            placeholder: 'Select One',
                            items: ['Enabled', 'Disabled'],
                            onSelect: function (header) {
                                let filter = {};

                                filter[header.filterName] = header.filter.model === 'Enabled';

                                sendRequest(filter);
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'NETWORK EFFECT SHARED MARGIN',
                        viewName: 'sharedMargin',
                        filterName: 'sharedMargin',
                        filter: {
                            type: 'select2',
                            placeholder: 'Select One',
                            items: ['Yes', 'No'],
                            onSelect: function (header) {
                                let filter = {};
                                filter[header.filterName] = header.filter.model === 'Yes';
                                sendRequest(filter);
                            }
                        }
                    },
                    {
                        label: 'RECEIVING RESELLERS',
                        viewName: 'receivingResellers',
                        filterName: 'receivingResellers',
                        width: '200px',
                        filter: {
                            type: 'autoComplete',
                            placeholder: 'Search',
                            viewName: 'receivingResellers',
                            items: [],
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header))
                            }
                        }
                    }
                ],
                data: [],
                onInit: function () {
                    sendRequest(additionalFilters);
                }
            };
            const tableActions = new TableLiteFactory(servicesTable,
                {
                    serviceCallback: ServicesService.getClientServiceLinks,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;
            let activeFilters = tableActions.activeFilters;
            function buildTableData(data, pagination) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item, index) {
                    item.href = '/margins/view/' + item.id;
                    item.carrierProfileName = angular.getObjVal(item, 'carrierProfile.name') ||
                        angular.getObjVal(item, 'serviceProfile.carrierProfile.name') || 'N/A';
                    item.serviceProfileName = angular.getObjVal(item, 'serviceProfile.name') || 'N/A';

                    if (angular.getObjVal(item, 'receivingResellers')) {
                        item.receivingResellers = {
                            type: 'multiLine',
                            list: item.receivingResellers.length > 0 ? item.receivingResellers.map(data => data.name) : ['N/A']
                        };
                    } else {
                        item.receivingResellers = {
                            type: 'multiLine',
                            list: ['N/A ']
                        }
                    }

                    if (angular.getObjVal(item, 'companyOffices')) {
                        item.companyName = {
                            type: 'multiLine',
                            list: item.companyOffices.length > 0 ? item.companyOffices.map(data => data.name) : ['N/A']
                        }
                    } else {
                        item.companyName = {
                            type: 'multiLine',
                            list: ['N/A']
                        }
                    }

                    item.marginMinValueFormatted = $filter('bbaCurrency')(item.marginMinValue, item.currency);
                    item.marginPercentFormatted = item.marginPercent ? item.marginPercent + ' %' : '0%';
                    item.status = {
                        type: 'status',
                        status: item.enabled,
                        label: item.enabled ? 'Enabled' : 'Disabled'
                    };
                    item.sharedMargin = item.sharedMargin ? 'Yes' : 'No';
                    servicesTable.data.push(item);
                });
                /*** END - Building of Data ***/
            }
            this.tableData = servicesTable;
        };
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/ServicesTableService.js